import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import { apiClientOld } from '@/_config/lib/axios/api-client-old';
import { GET_BALANCE_PLACE } from './constants';
import type { Balance } from '../types';

type GetBalancePlaceParams = {
  placeId: string;
};

const getBalancePlace = (params: GetBalancePlaceParams) => {
  const { placeId } = params;

  return apiClientOld
    .get<Balance>(`/estabelecimentos/${placeId}/bank/saldo`)
    .then(response => response.data)
    .catch(handleResponseThrowError());
};

type GetBalancePlaceResponse = Awaited<ReturnType<typeof getBalancePlace>>;

export const useGetBalancePlace = (
  params: GetBalancePlaceParams,
  options: Omit<
    UseQueryOptions<
      GetBalancePlaceResponse,
      unknown,
      GetBalancePlaceResponse,
      (string | GetBalancePlaceParams)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_BALANCE_PLACE, params],
    queryFn: () => getBalancePlace(params),
    ...options,
  });
};
